import { Component } from '@angular/core';
import { Router } from '@angular/router';

export type MiscReportSection = 'incident' | 'todolist' | 'drugStatistics' | 'paymentMethods';

@Component({
  selector: 'app-misc-report',
  templateUrl: './misc-report.component.html',
  styleUrls: ['./misc-report.component.css']
})
export class MiscReportComponent {

  activeSection: MiscReportSection = 'incident';

  constructor(public router: Router) { }

  get isSettingsMiscRoute(): boolean {
    return this.router.url.indexOf('/settings/misc-report') >= 0;
  }

  selectSection(section: MiscReportSection): void {
    this.activeSection = section;
  }

  get breadcrumbCurrent(): string {
    if (this.activeSection === 'drugStatistics') {
      return 'Drug Statistics';
    }
    if (this.activeSection === 'todolist') {
      return 'Auto Refills Report';
    }
    if (this.activeSection === 'incident') {
      return 'Incident Report';
    }
    if (this.activeSection === 'paymentMethods') {
      return 'Payment Methods';
    }
    return 'Misc Report';
  }
}
